export const deMinimisAidApplicationLocalization = {
  headerTitle: {
    nb: 'Erklæring om bagatellmessig støtte',
    nn: 'Fråsegn om bagatellmessig støtte',
    en: 'Declaration of De Minimis Aid',
  },
  customer: {
    nb: 'Kunde',
    nn: 'Kunde',
    en: 'Customer',
  },
  organizationNumber: {
    nb: 'Organisasjonsnummer',
    nn: 'Organisasjonsnummer',
    en: 'Organization Number',
  },
  earlierDeMinimisAidLabel: {
    nb: 'Tidligere bagatellmessig støtte',
    nn: 'Tidlegare bagatellmessig støtte',
    en: 'Previous De Minimis Aid',
  },
  payoutAmountLabel: {
    nb: 'Totalt tildelt støttebeløp i NOK',
    nn: 'Totalt tildelt støttebeløp i NOK',
    en: 'Total Awarded Aid Amount in NOK',
  },
  deMinimisAidTitle: {
    nb: 'Om erklæringen',
    nn: 'Om fråsegna',
    en: 'About the declaration',
  },
  deMinimisAidDescriptionPart1: {
    nb: 'Innovasjon Norge vurderer å tildele såkalt bagatellmessig støtte, som er et unntak fra det generelle forbudet mot offentlig støtte i EØS-avtalen. For å kunne motta bagatellmessig støtte, kreves det at støttemottaker ikke har mottatt mer enn 300 000 euro over en periode på tre år (eller 100 000 euro i veitransportsektoren). Hvis beløpsgrensen overskrides, kan støtten kreves tilbake i sin helhet.',
    nn: 'Innovasjon Noreg vurderer å tildele såkalla bagatellmessig støtte, som er eit unntak frå det generelle forbodet mot offentleg støtte i EØS-avtalen. For å kunne ta imot slik støtte, må mottakaren ikkje ha fått meir enn 300 000 euro over ein periode på tre år (eller 100 000 euro i vegtransportsektoren). Dersom grensa blir overskriden, kan støtta krevjast tilbake i sin heilskap.',
    en: 'Innovation Norway is considering granting so-called de minimis aid, which is an exception to the general prohibition on state aid under the EEA Agreement. To be eligible for de minimis aid, the recipient must not have received more than EUR 300,000 over a period of three years (or EUR 100,000 in the road transport sector). If the threshold is exceeded, the aid may be reclaimed in full.',
  },

  deMinimisAidDescriptionPart2: {
    nb: 'For å vurdere om vilkårene for slik tildeling er oppfylt, må det opplyses om foretaket og konsernet har mottatt bagatellmessig støtte i løpet av de siste tre år. Det må oppgis hvor mye som er mottatt i perioden totalt sett, inklusive eventuell bagatellmessig støtte fra Innovasjon Norge. Dersom foretaket eller andre foretak i samme konsern mottar bagatellmessig støtte i tidsrommet mellom innsendt erklæring og mottatt svar, må din rådgiver i Innovasjon Norge informeres om dette.',
    nn: 'For å vurdere om vilkåra for slik tildeling er oppfylte, må det opplysast om verksemda og konsernet har fått bagatellmessig støtte dei siste tre åra. Det må opplysast kor mykje som er motteke totalt i perioden, inkludert eventuell støtte frå Innovasjon Noreg. Dersom verksemda eller andre i same konsern får slik støtte mellom innsending av erklæring og svar, må rådgjevaren i Innovasjon Noreg få beskjed.',
    en: 'To assess whether the conditions for such aid are met, it must be disclosed whether the company and its group have received de minimis aid during the past three years. The total amount received during the period must be stated, including any de minimis aid from Innovation Norway. If the company or other companies in the same group receive de minimis aid between the submission of the declaration and the response, your advisor at Innovation Norway must be informed.',
  },

  deMinimisAidDescriptionPart3: {
    nb: 'Den som sender inn skjema må være bemyndiget til å gi erklæring på vegne av støttemottaker.',
    nn: 'Den som sender inn skjemaet må vere bemyndiga til å gi fråsegn på vegner av mottakaren.',
    en: 'The person submitting the form must be authorized to make the declaration on behalf of the aid recipient.',
  },

  deMinimisAidDescriptionPart4: {
    nb: 'Du kan lese mer om bagatellmessig støtte på våre nettsider, samt statsstøtteregelverket på {0}.',
    nn: 'Du kan lese meir om bagatellmessig støtte og statsstøtteregelverket på {0}.',
    en: 'You can read more about de minimis aid and the state aid rules on our website: {0}.',
  },
  accordionTitle: {
    nb: 'Rettslig grunnlag',
    nn: 'Rettssleg grunnlag',
    en: 'Legal basis',
  },
  accordionDescriptionPart1: {
    nb: `Det rettslige grunnlaget for tildeling av bagatellmessig støtte er gitt i {0}, som er gjort til norsk rett gjennom {1}`,
    nn: `Det rettslege grunnlaget for tildeling av bagatellmessig støtte er gitt i {0}, som er gjort til norsk rett gjennom {1}`,
    en: `The legal basis for granting de minimis aid is provided in {0}, which has been incorporated into Norwegian law through the {1}`,
  },
  accordionDescriptionPart2: {
    nb: 'For å kunne motta bagatellmessig støtte, kreves det at støttemottaker ikke har mottatt mer enn 300 000 euro i løpet av en treårsperiode, jf. forordningens artikkel 3 annet punkt. For støttemottakere innen veitransportsektoren skal bagatellmessig støtte i løpet av en treårsperiode ikke overstige 100 000 euro.',
    nn: 'For å kunne ta imot bagatellmessig støtte, må mottakaren ikkje ha fått meir enn 300 000 euro i løpet av ein treårsperiode, jf. forordninga artikkel 3 andre punkt. For mottakarar innan vegtransportsektoren skal slik støtte ikkje overstige 100 000 euro i same periode.',
    en: 'To be eligible for de minimis aid, the recipient must not have received more than EUR 300,000 over a three-year period, cf. Article 3, second paragraph of the regulation. For recipients in the road transport sector, de minimis aid must not exceed EUR 100,000 over the same period.',
  },
  accordionDescriptionLinkCommissionRegulation: {
    nb: 'Kommisjonsforordning 2023/2831',
    nn: 'Kommisjonsforordning 2023/2831',
    en: 'Commission Regulation 2023/2831',
  },
  accordionDescriptionLinkNorwegianRegulation: {
    nb: 'forskrift av 2. januar 2023 nr. 2 om unntak fra notifikasjonsplikt for offentlig støtte.',
    nn: 'forskrift av 2. januar 2023 nr. 2 om unntak frå meldeplikt for offentleg støtte.',
    en: 'regulation of 2 January 2023 No. 2 on exemptions from the notification requirement for state aid.',
  },
  customerDetails: {
    nb: 'Kundedetaljer',
    nn: 'Kundedetaljar',
    en: 'Customer details',
  },
  earlierDeMinimisAidDescription: {
    nb: 'Dersom foretaket eller andre foretak i samme konsern har mottatt bagatellmessig støtte i løpet av de siste tre år (foregående 36 måneder), må totalt tildelt støttebeløp oppgis i NOK. Dette inkluderer eventuell bagatellmessig støtte fra Innovasjon Norge.',
    nn: 'Dersom verksemda eller andre verksemder i same konsern har motteke bagatellmessig støtte i løpet av dei siste tre åra (dei føregåande 36 månadene), må det totale støttebeløpet oppgjevast i NOK. Dette inkluderer eventuell støtte frå Innovasjon Noreg.',
    en: 'If the company or other companies in the same group have received de minimis aid during the past three years (the preceding 36 months), the total amount of aid granted must be stated in NOK. This includes any de minimis aid from Innovation Norway.',
  },
  earlierDeMinimisAidLastTreeYears: {
    nb: 'Har foretaket eller andre foretak i samme konsern mottatt bagatellmessig støtte de siste tre år?',
    nn: 'Har verksemda eller andre verksemder i same konsern motteke bagatellmessig støtte dei siste tre åra?',
    en: 'Has the company or other companies in the same group received de minimis aid in the past three years?',
  },
  partners: {
    nb: 'Partnere',
    nn: 'Partnarar',
    en: 'Partners',
  },
  partner: {
    nb: 'Partner',
    nn: 'Partnar',
    en: 'Partner',
  },
  partnerDescription: {
    nb: 'Har dere partnere som også skal levere erklæring om bagatellmessig støtte?',
    nn: 'Har de partnarar som òg skal levere fråsegn om bagatellmessig støtte?',
    en: 'Do you have partners who also need to submit a de minimis aid declaration?',
  },
  delete: {
    nb: 'Slett',
    nn: 'Slett',
    en: 'Delete',
  },
  searchCompany: {
    nb: 'Søk opp bedriften',
    nn: 'Søk opp verksemda',
    en: 'Search for the company',
  },
  searchCompanyHelpText: {
    nb: 'Du kan søke på navn eller organisasjonsnummer.',
    nn: 'Du kan søkje på namn eller organisasjonsnummer.',
    en: 'You can search by name or organization number.',
  },
  uploadFileText: {
    nb: 'Last opp partners erklæring om bagatellmessig støtte',
    nn: 'Last opp partnaren si fråsegn om bagatellmessig støtte',
    en: 'Upload the partners de minimis aid declaration',
  },
  summaryPartnerTitle: {
    nb: 'Oppsummering og innsending',
    nn: 'Oppsummering og innsending',
    en: 'Summary and submission',
  },
  termsAndConditionsTitle: {
    nb: 'Betingelser og vilkår',
    nn: 'Vilkår og føresetnadar',
    en: 'Terms and Conditions',
  },
  termsAndConditionsPart1: {
    nb: 'Ved behandling av søknaden kan Innovasjon Norge hente inn informasjon fra banken din om ditt kundeforhold der.',
    nn: 'Ved behandling av søknaden kan Innovasjon Noreg hente inn informasjon frå banken din om ditt kundeforhold der.',
    en: 'When processing the application, Innovation Norway may obtain information from your bank about your customer relationship there.',
  },
  termsAndConditionsPart2: {
    nb: 'Dersom foretaket eller andre foretak i samme konsern har mottatt bagatellmessig støtte i løpet av de siste tre år (foregående 36 måneder), må totalt tildelt støttebeløp oppgis i NOK. Dette inkluderer eventuell bagatellmessig støtte fra Innovasjon Norge.',
    nn: 'Dersom verksemda eller andre verksemder i same konsern har motteke bagatellmessig støtte i løpet av dei siste tre åra (dei føregåande 36 månadene), må det totale støttebeløpet oppgjevast i NOK. Dette inkluderer eventuell støtte frå Innovasjon Noreg.',
    en: 'If the company or other companies in the same group have received de minimis aid during the past three years (the preceding 36 months), the total amount of aid granted must be stated in NOK. This includes any de minimis aid from Innovation Norway.',
  },
  termsAndConditionsPart3: {
    nb: 'Dersom foretaket eller andre foretak i samme konsern mottar bagatellmessig støtte i tidsrommet mellom innsendt erklæring og mottatt svar, må din rådgiver i Innovasjon Norge informeres om dette.',
    nn: 'Dersom verksemda eller andre verksemder i same konsern mottek bagatellmessig støtte i tidsrommet mellom innsending av fråsegn og motteke svar, må rådgjevaren i Innovasjon Noreg informerast om dette.',
    en: 'If the company or other companies in the same group receive de minimis aid between the submission of the declaration and the response, your advisor at Innovation Norway must be informed.',
  },
  termsAndConditionsPart4: {
    nb: 'Den som sender inn skjemaet må være bemyndiget til å gi erklæring på vegne av støttemottaker.',
    nn: 'Den som sender inn skjemaet må vere bemyndiga til å gi fråsegn på vegner av mottakaren.',
    en: 'The person submitting the form must be authorized to make the declaration on behalf of the aid recipient.',
  },
  confirmBeforeSubmission: {
    nb: 'Bekreft før innsending',
    nn: 'Stadfest før innsending',
    en: 'Confirm before submission',
  },
  confirmBeforeSubmissionCheckbox1: {
    nb: 'Jeg bekrefter at disse opplysningene stemmer',
    nn: 'Eg stadfestar at desse opplysningane er riktige',
    en: 'I confirm that this information is correct',
  },
  confirmBeforeSubmissionCheckbox2: {
    nb: 'Jeg bekrefter at jeg har lest og er kjent med Innovasjon Norges betingelser og vilkår for tildeling av bagatellmessig støtte',
    nn: 'Eg stadfestar at eg har lese og er kjent med Innovasjon Noreg sine vilkår og betingingar for tildeling av bagatellmessig støtte',
    en: 'I confirm that I have read and am familiar with Innovation Norway’s terms and conditions for granting de minimis aid',
  },
  confirmBeforeSubmissionCheckbox3: {
    nb: 'Jeg bekrefter at partneres erklæringer er vedlagt denne erklæringen',
    nn: 'Eg stadfestar at partnarane sine fråsegner er vedlagt denne fråsegna',
    en: 'I confirm that the partners’ declarations are attached to this declaration',
  },
  partnerDetails: {
    nb: 'Legg til informasjon om partnere',
    nn: 'Legg til informasjon om partnarar',
    en: 'Add information about partners',
  },
  partnerDetailsDescription: {
    nb: 'Last ned skjema for erklæring om bagatellmessig støtte. Alle partnere må fylle ut og signere. Last opp utfylte skjemaer her.',
    nn: 'Last ned skjema for fråsegn om bagatellmessig støtte. Alle partnarar må fylle det ut og signere. Last opp utfylte skjema her.',
    en: 'Download the de minimis aid declaration form. All partners must complete and sign it. Upload the completed forms here.',
  },
  earlierDeMinimisAidErrorLabel: {
    nb: 'Du må svare på om foretaket eller konsernet har mottatt bagatellmessig støtte de siste tre årene. Vennligst velg ett alternativ før du går videre.',
    nn: 'Du må svare på om verksemda eller konsernet har motteke bagatellmessig støtte dei siste tre åra. Ver venleg og vel eitt alternativ før du går vidare.',
    en: 'An answer is required as to whether the company or group has received de minimis aid in the past three years. Please select one option before continuing.',
  },
  partnerDescriptionErrorLabel: {
    nb: 'Du må oppgi om dere har partnere som også skal levere erklæring om bagatellmessig støtte. Vennligst velg ett alternativ før du fortsetter.',
    nn: 'Du må oppgi om de har partnarar som òg skal levere fråsegn om bagatellmessig støtte. Ver venleg og vel eitt alternativ før du held fram.',
    en: 'An answer is required as to whether you have partners who also need to submit a de minimis aid declaration. Please select one option before continuing',
  },
  payoutAmountRequired: {
    nb: 'Du må oppgi totalt tildelt støttebeløp',
    nn: 'Du må oppgi totalt tildelt støttebeløp',
    en: 'Please specify the total granted aid amount',
  },
} as const;
